<template>
    <model-form
        :title="role && role.id ? `Edit Role ${role.name}` : 'Create Role'"
        :formFields="formFields"
        @save="saveRole"
        @cancel="cancel"
    />
</template>

<script>
import { defineComponent } from "vue";

import ModelForm from "../common/models/ModelForm.vue";
import {
    buildCreateRoleAdminData,
    buildEditRoleAdminData,
    mapValuesToPermissions,
    roleService,
    updatePermissionOptionsConfig,
} from "@/lib/admin/roleAdmin.js";
import { buildMultiSelectField, buildNameField } from "@/lib/vueModelUtils.js";

async function buildRoleAdminData(roleId) {
    if (roleId) {
        return buildEditRoleAdminData(roleId);
    } else {
        return buildCreateRoleAdminData();
    }
}

export default defineComponent({
    name: "RoleForm",

    components: {
        ModelForm,
    },

    computed: {},

    async mounted() {
        const roleAdminData = await buildRoleAdminData(this.$route.params.id);
        this.role = roleAdminData.role;
        this.allPermissions = roleAdminData.allPermissions;
        this.buildFormFields(
            roleAdminData.allPermissionOptions,
            roleAdminData.selectedPermissionValues
        );
    },

    methods: {
        handlePermissionChange(selectedPermissionValues) {
            const config = updatePermissionOptionsConfig(
                selectedPermissionValues,
                this.allPermissions
            );
            this.permissionsField.options = config.allPermissionOptions;
            this.permissionsField.values = config.selectedPermissionValues;
        },
        buildFormFields(allPermissionOptions, selectedPermissionValues) {
            this.nameField = buildNameField(this.role.name);
            this.permissionsField = buildMultiSelectField({
                name: "Permissions",
                options: allPermissionOptions,
                values: selectedPermissionValues,
                changed: (values, formField) => {
                    this.handlePermissionChange(values, formField);
                },
            });

            this.formFields = [this.nameField, this.permissionsField];
        },
        async saveRole() {
            this.saving = true;
            this.role.name = this.nameField.value;
            this.role.permissions = mapValuesToPermissions(this.permissionsField.values);
            await roleService.save(this.role);
            this.saving = false;
            this.$router.push(`/auth/admin`);
        },
        cancel() {
            this.$router.push(`/auth/admin`);
        },
    },

    data() {
        return {
            isFormValid: false,
            saving: false,
            role: null,
            allPermissions: [],
            formFields: [],
        };
    },
});
</script>

<style></style>
